import {createSelector} from "reselect";

const inventories = (state) => state.inventories;

const inventoryData = createSelector(
  inventories,
  (inventory) => inventory.inventoriesData || {}
);

export const getInventories = createSelector(inventoryData, (inventoryData) => {
  const inventoryList = inventoryData.results || [];
  // Note: Negating alarm to show green color for false and red color for true in table.
  // As logic written in table is opposite of this
  return inventoryList.map((inventory) => ({
    ...inventory,
    alarm: typeof inventory.alarm === "boolean" ? !inventory.alarm : inventory.alarm,
  }));
});

export const getInventoryTotalCount = createSelector(
  inventoryData,
  (inventoryData) => inventoryData.total_count
);

export const getUserPaginationUrls = createSelector(inventoryData, (inventoryData) => ({
  prevUrl: inventoryData.previous,
  nextUrl: inventoryData.next,
}));
